
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telus/health/press-releases/[...slug]",
      function () {
        return require("private-next-pages/telus/health/press-releases/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telus/health/press-releases/[...slug]"])
      });
    }
  